import appEnv from 'app/config/appEnv';

function getTribeAdminLink(
  id: string,
  type: 'authorize' | 'account' | 'card' | 'holder' | 'transaction'
) {
  const baseUrl = appEnv.VITE_TRIBE_ADMIN_BASE_URL;
  const programManager = appEnv.VITE_TRIBE_ADMIN_PROGRAM_MANAGER;

  let tribeAdminLink = `${baseUrl}/${programManager}/${type}`;

  switch (type) {
    case 'authorize':
    case 'holder':
      tribeAdminLink += '/view';
      break;
    case 'account':
    case 'card':
    case 'transaction':
    default:
      tribeAdminLink += '/show';
      break;
  }

  return `${tribeAdminLink}/${id}`;
}

export default getTribeAdminLink;
